/*jshint esversion: 6 */

import React from "react";
import isArray from "lodash/isArray";
import isEmpty from 'lodash/isEmpty'
import ReactPlayer from "react-player";
import { isMobile } from "../helpers/isMobile";
class CaQuestion extends React.Component {
  constructor(props) {
    super(props);

    this.onInputChange = this.onInputChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.videoOrTextQuestion = this.videoOrTextQuestion.bind(this);
  }

  onKeyPress(event) {
    if (event.key === "Enter") {
      this.onDone();
    }
  }

  onDone() {
    this.props.onAnswerSet(this.props.question, this.state.answer);
  }

  onInputChange(event) {
    this.setState({ answer: event.target.value });
  }

  videoOrTextQuestion() {
    const { question } = this.props;
    if (
      question &&
      question["question-meta"] &&
      question["question-meta"].video_or_text !== "video" &&
      question["question-meta"].question
    ) {
      return (
        <h2 className={"QuizQuestion__body"}>
          {question["question-meta"].question}
        </h2>
      );
    }
    if (
      question &&
      question["question-meta"] &&
      question["question-meta"].video_or_text === "video" &&
      question["question-meta"].video_quiz_url
    ) {
      const videoPlayerProps = {
        url: question["question-meta"].video_quiz_url,
        playing: false,
        loop: true,
        volume: 1,
        muted: false,
        controls: true,
        playsinline: true,
        width: "100%",
        height: "100%"
      };
      return (
        <React.Fragment>
          <h2 className={"QuizQuestion__body"} style={{ marginBottom: "20px" }}>
            {question["question-meta"].question}
          </h2>
          <div className="player-wrapper">
            <ReactPlayer className="react-player" {...videoPlayerProps} />
          </div>
        </React.Fragment>
      );
    }
  }

  render() {
    const options = this.props.question["question-meta"].options; // TODO: Dont assume!!!!

    const id = this.props.question.id;
    return (
      <div>
        {isArray(this.props.question["question-meta"].featuredImage) && (
          <img
            className={"QuizQuestion__image"}
            src={this.props.question["question-meta"].featuredImage[0]}
            width={this.props.question["question-meta"].featuredImage[1]}
            height={this.props.question["question-meta"].featuredImage[2]}
          />
        )}
        {this.videoOrTextQuestion()}
        <div className={"QuizQuestion__answers"}>
          {!isEmpty(this.props.question["question-meta"].free_text) && (
            <div className={"QuizQuestion__freetextWrapper"}>
              <input
                className={"QuizQuestion__freetext"}
                name="answer"
                onChange={this.onInputChange}
                onKeyPress={this.onKeyPress}
                type="text"
              />
              <div className={"QuizQuestion__buttonWrapper"}>
                <button
                  className={"QuizQuestion__submitButton"}
                  onClick={() => this.onDone()}
                >
                  {this.props.freeTextCta}
                </button>
              </div>
            </div>
          )}
          {options &&
            Object.keys(options).map((key, i) => (
              <button
                id={"button_" + i + id}
                className={"QuizQuestion__answerButton"}
                onClick={() => this.props.onAnswerSet(this.props.question, key)}
                key={i + id}
              >
                <span className={"QuizQuestion__answerButtonChar"}>
                  {String.fromCharCode(65 + i)}
                </span>
                <span className={"QuizQuestion__answerButtonText"}>
                  {options[key]}
                </span>
              </button>
            ))}
        </div>
      </div>
    );
  }
}
export default CaQuestion;
